import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import BasicInfoSection from '../CreateMenuPage/components/BasicInfoSection';
import DetailedSettingsSection from '../CreateMenuPage/components/DetailedSettingsSection';
import CombinationSection from '../CreateMenuPage/components/CombinationSection';
import NotesSection from '../CreateMenuPage/components/NotesSection';
import LoadingProgress from 'app/components/commonUI/LoadingProgress';
import { getMenuById } from 'app/services/api';

function DetailMenuManagementComponent({ menuId, onNotFound, onError, showLoading = true }) {
  const [customTags, setCustomTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
      category: '',
      treatmentTime: '',
      managementTags: [],
      targetAudiences: [],
      recommendedMenus: [],
      avoidSimultaneousMenus: [],
      avoidConditions: [],
      customerNotes: '',
      publicStatus: true,
      showOnBookingSite: true,
      isDraft: false,
    },
    onSubmit: () => {},
    enableReinitialize: false,
  });

  const { values, errors, setFieldValue, setValues } = formik;

  useEffect(() => {
    if (!menuId) return;

    const loadMenuData = async () => {
      setIsLoading(true);

      try {
        const res = await getMenuById(menuId);
        const menu = res.data;

        if (menu) {
          setValues({
            name: menu.name || '',
            description: menu.description || '',
            category: menu.category || '',
            treatmentTime: menu?.treatmentTime ? menu.treatmentTime.toString() : '',
            managementTags: menu.managementTags || [],
            targetAudiences: menu.targetAudiences || [],
            recommendedMenus: menu.recommendedMenus || [],
            avoidSimultaneousMenus: menu.avoidSimultaneousMenus || [],
            avoidConditions: menu.avoidConditions || [],
            customerNotes: menu.customerNotes || '',
            publicStatus: menu.publicStatus ?? false,
            showOnBookingSite: menu.showOnBookingSite !== false,
            isDraft: menu.isDraft || false,
          });

          const defaultTags = ['新規顧客限定', '平日限定', '期間限定'];
          const custom = (menu.managementTags || []).filter((tag) => !defaultTags.includes(tag));
          setCustomTags(custom);
        } else {
          toast.error('メニューが見つかりません');
          onNotFound?.();
        }
      } catch (error) {
        console.error('Load menu error:', error);
        toast.error('メニュー取得に失敗しました');
        onError?.();
      } finally {
        setIsLoading(false);
      }
    };

    loadMenuData();
  }, [menuId, setValues, onNotFound, onError]);

  if (isLoading && showLoading) {
    return <LoadingProgress />;
  }

  return (
    <div className="w-full">
      <BasicInfoSection values={values} errors={errors} setFieldValue={setFieldValue} readonly={true} />

      <DetailedSettingsSection
        values={values}
        setFieldValue={setFieldValue}
        customTags={customTags}
        setCustomTags={setCustomTags}
        readonly={true}
      />

      <CombinationSection values={values} setFieldValue={setFieldValue} readonly={true} />

      <NotesSection values={values} setFieldValue={setFieldValue} readonly={true} />
    </div>
  );
}

export default DetailMenuManagementComponent;
